module.exports = __webpack_public_path__ + "static/media/paske-4.4ff04662.jpg";